// Extrait de NursePatientDetail / DoctorPatientDetail (handover bloc F2, B4) — 9 onglets identiques aux deux rôles.
import { ClipboardList, Pill, TrendingUp, AlertTriangle, Activity, History, FlaskConical, FileText } from "lucide-react";

export const PATIENT_DETAIL_TABS = [
  { id: "overview", label: "Vue d'ensemble", icon: Activity },
  { id: "graphs", label: "Graphiques", icon: TrendingUp },
  { id: "biology", label: "Biologie", icon: FlaskConical },
  { id: "history", label: "Historique", icon: History },
  { id: "plan", label: "Plan de traitement", icon: Pill },
  { id: "studies", label: "Études", icon: FlaskConical },
  { id: "dossier", label: "Dossier médical", icon: FileText },
  { id: "checkins", label: "Check-ins", icon: ClipboardList },
  { id: "alerts", label: "Alertes", icon: AlertTriangle },
];
